<template>
  <b-dropdown
    ref="assistantsAvatarRef"
    no-caret >
    <template #button-content>
      <span
        class="avatar-btn"
        :class="[`av-${selectedAvatar+1}`]" />
    </template>
    <div>
      <!-- <template v-if="icons.length">
        <span
          v-for="(icon, index) in icons"
          :key="index"
          class="avatar-btn"
          :style="{ backgroundImage: `url(${icon})` }"
          @click="selectAvatar(index)" />
      </template> -->
      <span
        v-for="i in [...Array(7).keys()].slice(1)"
        :key="i"
        class="avatar-btn"
        :class="[`av-${i}`]"
        @click="selectAvatar(i-1)" />
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'AvatarGridSelect',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: 1,
    },
    icons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedAvatar: 1,
      initialized: false,
    };
  },
  watch: {
    value() {
      if (!this.initialized) {
        const index = this.icons.findIndex(icon => icon === this.value);
        this.selectAvatar(index <= 0 ? 0 : index);
        this.initialized = true;
      }
    },
  },
  mounted() {
    window.eventBus.$on('stepperInitialized', () => {
      if (!this.initialized) {
        this.selectAvatar(0);
      }
    });
  },
  methods: {
    selectAvatar(index) {
      this.selectedAvatar = index;
      if (this.$refs.assistantsAvatarRef) {
        this.$refs.assistantsAvatarRef.hide();
      }
      this.$emit('input', this.icons.length ? this.icons[index] : index);
      window.eventBus.$emit('formSchemaAvatar', `av-${index + 1}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown.avatar-select {
  height: 32px;

  ::v-deep button.dropdown-toggle {
    border-radius: 10px 0 0 10px !important;
    background-color: transparent;
    padding: 6px 11px !important;
    border-right: 1px solid $greyBorder !important;
    &:hover {
      background-color: $greyUltralight;
    }
  }
}

.avatar-btn {
  display: block;
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-position: center;

  @for $i from 1 through 6 {
    &.av-#{$i} {
      background-image: url('~@/assets/img/icons/assistant-avatars/av-#{$i}.svg');
    }
  }
}

::v-deep .btn.dropdown-toggle {
  margin-top: 0 !important;
}

::v-deep ul.dropdown-menu {
  background: $greyBorderSecondary !important;
  border-radius: 10px !important;
  min-width: fit-content;
  margin-top: 4px !important;

  div {
    display: flex !important;
    gap: 1px;
    flex-wrap: wrap;
    max-width: 122px;
    min-width: 40px;
    width: 122px;
    span.avatar-btn {
      width: 40px !important;
      height: 35px !important;
      background-color: $white !important;
      &:hover {
        background-color: $greyUltralight !important;
        cursor: pointer;
      }
      a {
        display: none;
      }
    }
  }
}
</style>
